import * as requestFromServer from './newInvoiceOrdersCountCrud';

export const getNewInvoiceOrdersCount = () => {

  return requestFromServer
    .getNewInvoiceOrdersCount()
    .then(response => {
      const {errorCode, data: {count}} = response.data;
      if (errorCode !== 0) throw new Error();

      return count
    })
};